import { apiSlice } from "../baseQuery";
import { Row, Rows } from "../type";
import {
  CreditDto,
  CreditStatusInfoDto,
  CreditUsedHistoryDto,
  GenerateCreditDto,
  GetCreditsRequest,
  GetCreditUsedHistoriesRequest,
} from "./interface";

const apiWithTag = apiSlice.enhanceEndpoints({
  addTagTypes: ["creditTotal"],
});

const creditApi = apiWithTag.injectEndpoints({
  endpoints: (build) => ({
    // 크레딧(유효기간이 남은 소멸예정이 아닌) 현황 조회 API
    getCreditStatusInfo: build.query<CreditStatusInfoDto, void>({
      query: () => ({
        url: "/credits/dashboard/credit-status-info",
      }),
      providesTags: ["creditTotal"],
      transformResponse: (res: Row<CreditStatusInfoDto>) => res.row,
    }),

    // 크레딧 목록 조회 API
    getCredits: build.query<Rows<CreditDto>, GetCreditsRequest>({
      query: (params) => ({
        url: "/credits",
        params,
      }),
    }),

    // 크레딧 생성 API
    createCredit: build.mutation<CreditDto, GenerateCreditDto>({
      query: (body) => ({
        method: "POST",
        url: "/credits",
        body: body,
      }),
      invalidatesTags: ["creditTotal"],
      transformResponse: (res: Row<CreditDto>) => res.row,
    }),

    // 크레딧 사용 내역 목록 조회 API
    getCreditUsedHistories: build.query<
      Rows<CreditUsedHistoryDto>,
      GetCreditUsedHistoriesRequest
    >({
      query: (params) => ({
        url: "/credit-used-histories",
        params,
      }),
    }),
  }),
});

export const {
  useGetCreditStatusInfoQuery,
  useLazyGetCreditStatusInfoQuery,
  useLazyGetCreditsQuery,
  useCreateCreditMutation,
  useLazyGetCreditUsedHistoriesQuery,
} = creditApi;
export { creditApi };
